import React from "react";
import undoIcon from "../style/undo-icon.svg";

interface ActionBarProps {
  hasUserAppliedFilters: boolean;
  displayedPhotosCount: number;
  onClearFilters: () => void;
  photosLength: number;
  allSelected: boolean;
  onSelectAll: (event: React.ChangeEvent<HTMLInputElement>) => void;
  someSelected: boolean;
  isDownloading: boolean;
  onDownload: () => void;
  onTag: () => void;
  onHide: () => void;
  onDelete: () => void;
  hideOrUnhideText: string;
}

const ActionBar: React.FC<ActionBarProps> = ({
  hasUserAppliedFilters,
  displayedPhotosCount,
  onClearFilters,
  photosLength,
  allSelected,
  onSelectAll,
  someSelected,
  isDownloading,
  onDownload,
  onTag,
  onHide,
  onDelete,
  hideOrUnhideText
}) => {
  return (
    <div className="filtered-select-row">
      <div className="flex-row photos-view-actions">
        {hasUserAppliedFilters && (
          <div className="filtered-results-count filtered-results-count--desktop">
            <span className="filtered-results-count__text">
              {displayedPhotosCount} photo
              {displayedPhotosCount !== 1 ? "s" : ""} found
            </span>
            <button
              className="filtered-results-count__refresh"
              onClick={onClearFilters}
              title="Clear all filters"
            >
              <img
                src={undoIcon}
                alt="Clear filters"
                width="14"
                height="14"
              />
            </button>
          </div>
        )}
        <div className="select-all-btn">
          <span className="check-radio checkmark">
            <label
              htmlFor="filtered-select-all"
              className="geo-tag-b__selectall"
            >
              <input
                id="filtered-select-all"
                type="checkbox"
                checked={allSelected}
                className="geo-form__checkbox"
                onChange={onSelectAll}
              />
              <span className="r-dot"></span>
              <span className="r-desc">
                {photosLength < 50
                  ? "Select all"
                  : `Select all visible (${photosLength})`}
              </span>
            </label>
          </span>
        </div>
      </div>
      <div className="ws-action-section">
        <button
          className="geo-btn geo-btn--secondary-ghost geo-btn--caps geo-btn--small"
          onClick={onDownload}
          disabled={!someSelected || isDownloading}
        >
          {isDownloading ? "Preparing..." : "Download"}
        </button>
        <button
          className="geo-btn geo-btn--secondary-ghost geo-btn--caps geo-btn--small"
          onClick={onTag}
          disabled={!someSelected}
        >
          Tag
        </button>
        <button
          className="geo-btn geo-btn--secondary-ghost geo-btn--caps geo-btn--small"
          onClick={onHide}
          disabled={!someSelected}
        >
          {someSelected ? hideOrUnhideText : "hide"}
        </button>
        <button
          className="geo-btn geo-btn--secondary-ghost geo-btn--caps geo-btn--small"
          onClick={onDelete}
          disabled={!someSelected}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default ActionBar;
